import type { Components, Theme } from '@mui/material';

export const MuiSwitch: Components<Theme>['MuiSwitch'] = {
  styleOverrides: {
    switchBase: ({ theme }) => ({
      '&.Mui-checked': {
        color: theme.palette.primary.dark,
      },
      '&.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.dark,
      },
    }),
  },
};
